import ApiConection from "api_ref/ApiConection";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function CustomerActions() {

    const navigate = useNavigate();
    const api = new ApiConection();
    const { id } = useParams();

    const [disabledChangePackage, setDisabledChangePackage] = useState(false);
    const [disabledChangeAddon, setDisabledChangeAddon] = useState(false);

    const handleUpgradeMainPackage = () => {
        navigate(`/company/detail/${id}/upgrade-next-main-package`);
    }
    const handleUpgradeAddOnPackage = () => {
        navigate(`/company/detail/${id}/upgrade-add-on-package`);
    }

    const getCanChangePackage = async () => {
        //setLoadingCheckPackage(true);

        const response = await api.getData(`api/quontation/register/${id}/can-change-package`);
        //console.log('package=',response);
        setDisabledChangePackage(response);
    }

    const getCanChangeAddon = async () => {
        //setLoadingCheckAddon(true);

        const response = await api.getData(`api/quontation/register/${id}/can-change-addon`);
        //console.log('addon=',response);
        setDisabledChangeAddon(response);
    }

    useEffect(() => {
        getCanChangePackage();
        getCanChangeAddon();
    }, []);
    return (
        <div className="border rounded p-4 bg-white shadow w-100">
            <button type='button' className="btn btn-outline-secondary  me-2" disabled={!disabledChangePackage.status} onClick={handleUpgradeMainPackage}>อัปเกรดแพ็กเกจหลักในรอบถัดไป<i className="ms-2 fa-solid fa-pencil"></i></button>
            <button type='button' className="btn btn-outline-secondary " disabled={!disabledChangeAddon.status} onClick={handleUpgradeAddOnPackage}>อัปเกรดแพ็กเกจเสริม<i className="ms-2 fa-solid fa-pencil"></i></button>
        </div>
    )
}